/**
 * report.ts — สร้าง P&L report + drill-down map จาก demo data (web side)
 * ใช้ engine เดียวกับ backend
 */
import { buildPnlReport, type PnlLineKey, type PnlCategory } from '@rrp/shared';
import { demoCurrent, demoPrevMonth } from './demo-data.js';

export const APR = { from: '2025-04-01', to: '2025-04-30' };
export const MAR = { from: '2025-03-01', to: '2025-03-31' };

export const currentReport = buildPnlReport(demoCurrent, APR);
export const prevReport = buildPnlReport(demoPrevMonth, MAR);

export interface DrillRow {
  date: string;
  label: string;
  amount: string; // signed string
}

const LINE_CATEGORY: Partial<Record<PnlLineKey, PnlCategory>> = {
  marketing_expenses: 'marketing_expenses',
  commissions_platform_fees: 'commissions_platform_fees',
  transportation_fulfillment: 'transportation_fulfillment',
  payroll_employee: 'payroll_employee',
  accounting_professional: 'accounting_professional',
  fixed_cost: 'fixed_cost',
  variable_cost: 'variable_cost',
  other_operating: 'other_operating',
  depreciation_amortization: 'depreciation_amortization',
  interest_finance: 'interest_finance',
  other_income: 'other_income',
};

/** รายการที่ประกอบเป็นบรรทัด P&L (drill-down) — คืน [] ถ้าเป็นบรรทัดคำนวณ */
export function drilldownFor(key: PnlLineKey): DrillRow[] {
  if (key === 'sales') {
    const rows: DrillRow[] = demoCurrent.sales.map((s) => ({
      date: s.date,
      label: 'ยอดขาย',
      amount: String(s.revenue),
    }));
    for (const r of demoCurrent.refunds) {
      rows.push({ date: r.date, label: 'คืนสินค้า/คืนเงิน', amount: `-${String(r.amount)}` });
    }
    return rows.sort((a, b) => a.date.localeCompare(b.date));
  }
  if (key === 'cost_of_products') {
    return demoCurrent.sales
      .filter((s) => s.cost !== null)
      .map((s) => ({ date: s.date, label: 'ต้นทุนสินค้า', amount: String(s.cost) }));
  }
  const cat = LINE_CATEGORY[key];
  if (cat) {
    return demoCurrent.costs
      .filter((c) => c.category === cat)
      .map((c) => ({ date: c.date, label: cat, amount: String(c.amount) }));
  }
  return [];
}
